import { Card, DatePicker, Descriptions, Form, Select } from 'antd';
import { observer } from 'mobx-react-lite';

import {
  FormItemAdapter,
  nullMomentToNullString,
  nullStringToNullMoment,
} from 'app/libs/form-item-adapter';

import { TrainType, TTrip } from '../../core/trips';
import { requiredRules, useErrorFieldsStatusContext } from './form-utils';

type RouteCardProps = {
  trip: TTrip;
  trainTypes: TrainType[];
};
export const RouteCard = observer(({ trip, trainTypes }: RouteCardProps) => {
  const errorFieldsStatus = useErrorFieldsStatusContext();

  return (
    <Card size="small" title="Маршрут" extra={<span>ID: {trip.route.id}</span>}>
      <Descriptions bordered size="small" column={1}>
        <Descriptions.Item
          label="Направление"
          labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
        >
          {trip.route.nameRu}
        </Descriptions.Item>

        <Descriptions.Item
          label="Тип состава"
          labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
        >
          <Form.Item
            name={['trainType', 'id']}
            rules={requiredRules}
            noStyle={true}
          >
            <Select
              style={{ width: '50%' }}
              status={errorFieldsStatus.getFieldStatus(['trainType', 'id'])}
            >
              {trainTypes.map((trainType) => (
                <Select.Option key={trainType.id} value={trainType.id}>
                  {trainType.nameRu}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Descriptions.Item>

        <Descriptions.Item
          label="Время отправления"
          labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
        >
          <Form.Item name="startTime" rules={requiredRules} noStyle={true}>
            <FormItemAdapter
              valueFormat={nullStringToNullMoment}
              onChangeFormat={nullMomentToNullString}
            >
              {(value, onChange) => (
                <DatePicker
                  showTime
                  status={errorFieldsStatus.getFieldStatus('startTime')}
                  format={'HH:mm DD.MM.YYYY'}
                  value={value as any}
                  onChange={onChange as any}
                  style={{ width: '50%' }}
                />
              )}
            </FormItemAdapter>
          </Form.Item>
        </Descriptions.Item>

        <Descriptions.Item
          label="Время прибытия"
          labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
        >
          <Form.Item name="finishTime" rules={requiredRules} noStyle={true}>
            <FormItemAdapter
              valueFormat={nullStringToNullMoment}
              onChangeFormat={nullMomentToNullString}
            >
              {(value, onChange) => (
                <DatePicker
                  showTime
                  status={errorFieldsStatus.getFieldStatus('finishTime')}
                  format={'HH:mm DD.MM.YYYY'}
                  value={value as any}
                  onChange={onChange as any}
                  style={{ width: '50%' }}
                />
              )}
            </FormItemAdapter>
          </Form.Item>
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
});
